import React from "react";
import HeroSection from "../components/HeroSection";
import LoanPromoSection from "../components/LoanPromoSection";
import LoanStepsSection from "../components/LoanStepsSection";
import HelpSection from "../components/HelpSection";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <LoanPromoSection />
      <LoanStepsSection />
      <HelpSection />
    </div>
  );
};

export default Home;
